<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/Q3BhN7/tc-custom/9781473896703.jpg?1705359758053" alt="This image is the cover for the book Heartbeat and Beyond"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Heartbeat and Beyond
      </h1>
      <p class="bookDescription body article font2">
        <p>In 1968 a group of young people took over a derelict trouser factory in a rundown part of Leeds and set about producing programmes that were to define the British television world of the late 20th Century.These included the investigative documentary series First Tuesday, Darling Buds of May, Whickers World, Dont Ask Me and Heartbeat.At the same time they attracted, indeed often created, stars of international fame such as James Mason, Catherine Zeta Jones, Alan Whicker, David Jason, Magnus Pike and David Frost.Fifty years on, their achievements and experiences, often dramatic and frequently absurd, make for fascinating behind-the-scenes reading. This book paints a colourful and entertaining picture of the making from virtually nothing of one of the greatest television channels of all times.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        John Fairley, Graham Ironside
      </h2>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Pen and Sword
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?20503ec7